module.exports = __webpack_public_path__ + "media/assets/images/icons/binnacle-icon1-2be46c506c4b032068a1150d153b87a7.svg";